/* eslint-disable no-unused-vars */
import React from 'react';
import { useParams } from 'react-router';
import { StartIcon, PauseAction } from 'assets/icons';
import * as S from './StartPauseBtn.styled';
import { manageAppsAPI } from 'services/manageApps.service';
import { IconButton } from 'components';

const btnIcon = {
  3: StartIcon,
  0: PauseAction,
};

const StartPauseBtn = ({ placement_id, status, name: placementName }) => {
  const { pba_id } = useParams();
  const [upDatePlacement] = manageAppsAPI.useUpDatePlacementMutation();

  const handleItemClick = () => {
    upDatePlacement({
      data: { name: placementName, id: placement_id, status: status === '0' ? '3' : '0' },
      pba_id,
    });
  };

  const IconToShow = btnIcon[+status];
  return (
    <S.BtnWrapp>
      <IconButton.SmallSize
        isDefaultMuted
        icon={IconToShow}
        type={IconButton.btnTypes.tertiary}
        onClick={handleItemClick}
      />
    </S.BtnWrapp>
  );
};

export default StartPauseBtn;
